
import { mapGetters } from "vuex";
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import TableApp from "@/components/Table/Table2";
import { onboardStore } from "../../../onboardStore";
import { SistemaMixin } from "@/modules/Application";
import CadastroEmpresaCopiarButton from "@/modules/GrupoEmpresa/components/CadastroEmpresaCopiarButton.vue";
import { cadastroEmpresaCopiaMixin } from "@/modules/GrupoEmpresa/mixins/cadastroEmpresaCopia";

export default {
  name: "app-un",
  components: {
    Pencil,
    TrashCanIcon,
    TableApp,
    CadastroEmpresaCopiarButton,
  },
  mixins: [SistemaMixin, cadastroEmpresaCopiaMixin],
  data() {
    return {
      onboardStore,
      fields: [
        {
          label: "Descrição",
          field: "nome",
          type: "text",
          sortable: false,
          width: "60%",
          filterOptions: {
            enabled: false,
            placeholder: "Pesquisar Descrição",
          },
        },
        {
          label: "Sigla",
          field: "sigla",
          type: "text",
          sortable: false,
          width: "20%",
          filterOptions: {
            enabled: false,
            placeholder: "Pesquisar Sigla",
          },
        },
        {
          label: "",
          field: "actions",
          sortable: false,
          slot: true,
          width: "15%",
          filterOptions: {
            enabled: false,
          },
        },
      ],
    };
  },
  methods: {
    excluir(data) {
      this.getRequestAdmin(() => {
        this.$swal
          .fire({
            icon: "warning",
            title: "Excluir a unidade de media: " + data.nome + "?",
            showCancelButton: true,
            confirmButtonText: `Sim`,
            cancelButtonText: `Não`,
            confirmButtonColor: "#f64e60",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              await this.$http.post("/produtos/delete-unidades-medidas", {
                id: data.id,
              });
              this.$refs.un.refresh();
              this.$toast.success("Unidade de medida excluída!");
            }
          });
      });
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    config() {
      return this.layoutConfig();
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
